module Meevo.Components.Filters {

    export function meevoTruncateFilter(): any {
        const filter = (input: any, shortenLength: number, maxLength?: number, decimalLimit?: number): string => {

            if (maxLength) {
                if (input.length > maxLength) {
                    input = input.slice(0, input.length - shortenLength);
                }
            } else if (decimalLimit) {
                var temp = input.toString().split('.');
                if (temp[1]) {
                    input = parseFloat(temp[0] +'.'+ temp[1].substring(0, decimalLimit));
                }
            }
            return input;
        }

        return filter;
    }

    angular.module("meevo.components.filters")
        .filter("meevoTruncate", meevoTruncateFilter);
}